import { render, staticRenderFns } from "./ActionLabel.vue?vue&type=template&id=0fff803c&"
import script from "./ActionLabel.vue?vue&type=script&lang=ts&"
export * from "./ActionLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports